export interface RecipeProductType {
  id:number;
  name: string;
  productType: number;
  countryId: number;
  createdOn: Date;
}

export function createDefaultProductType(): RecipeProductType {
  return {
    createdOn: null,
    id: 0,
    name: '',
    productType: 0,
    countryId: 0
  };
}